/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner } from './save-deal-as-return-to-editing200-response-card-transaction-evidence-list-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsReturnToEditing200ResponseIntegratedBy } from './save-deal-as-return-to-editing200-response-integrated-by';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsReturnToEditing200ResponseInvoiceIssuer } from './save-deal-as-return-to-editing200-response-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsReturnToEditing200ResponseJournalEntriesInner } from './save-deal-as-return-to-editing200-response-journal-entries-inner';
// May contain unused imports in some cases
// @ts-ignore
import { SaveDealAsReturnToEditing200ResponseJournalizedBy } from './save-deal-as-return-to-editing200-response-journalized-by';

/**
 * 
 * @export
 * @interface SaveDealAsReturnToEditing200Response
 */
export interface SaveDealAsReturnToEditing200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'status': SaveDealAsReturnToEditing200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealAsReturnToEditing200ResponseJournalizedBy}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'journalizedBy': SaveDealAsReturnToEditing200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealAsReturnToEditing200ResponseIntegratedBy}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'integratedBy': SaveDealAsReturnToEditing200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealAsReturnToEditing200ResponseJournalEntriesInner>}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'journalEntries': Array<SaveDealAsReturnToEditing200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealAsReturnToEditing200ResponseInvoiceIssuer}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'invoiceIssuer': SaveDealAsReturnToEditing200ResponseInvoiceIssuer | null;
}

export const SaveDealAsReturnToEditing200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealAsReturnToEditing200ResponseStatusEnum = typeof SaveDealAsReturnToEditing200ResponseStatusEnum[keyof typeof SaveDealAsReturnToEditing200ResponseStatusEnum];


